import { useEffect, useState } from "react";

export function ReadingProgress() {
  const [pct, setPct] = useState(0);
  useEffect(() => {
    const onScroll = () => {
      const doc = document.documentElement;
      const max = doc.scrollHeight - window.innerHeight;
      const v = max > 0 ? (window.scrollY / max) * 100 : 0;
      setPct(Math.min(100, Math.max(0, v)));
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);
  return (
    <div aria-hidden="true" className="no-print fixed inset-x-0 top-0 z-50 h-[3px] bg-transparent">
      <div
        className="h-full transition-[width] duration-100 ease-out"
        style={{
          width: `${pct}%`,
          backgroundImage:
            "linear-gradient(90deg, oklch(0.66 0.26 28), oklch(0.6 0.28 305), oklch(0.6 0.26 265))",
          boxShadow: "0 0 12px oklch(0.6 0.28 305 / 0.6)",
        }}
      />
    </div>
  );
}
